export default {
  help: {
    'a': ' 一、APP其他功能',
    'b': ' [首頁]您可以查看最新測量信息，心率健康趨勢，健康數據統計。 ',
    'c': '[歷史]查看歷史測量記錄。 ',
    'd': '[測量]連接心電設備，獲取測量數據結果。 ',
    'e': '[家人] 您可以替家人或朋友創建附屬賬號，還可以綁定家人或朋友已有賬號，與他們一起使用本產品及服務。 ',
    'f': '[設置] 可進行賬號相關設置。 ',
    'g': '二、設備電源管理',
    'h': '本設備處於待機狀態時，閒置 3分鐘便會自動關機，您也可以在使用完畢後，持續按壓電源開關約 2秒關閉設備電源。當設備電量偏低時，會每 5秒“嗶”一聲進行提示，同時電源指示燈閃爍，此時仍可操作，但請您盡快進行充電。當設備電量極低時，開啟後會長“嗶”一聲並即刻自動關機，此時請立即為設備充電。 ',
    'i': '三、注意事項',
    'j': '電池相關問題',
    'k': 'Q1.第一次使用心美特時需要充電多久？ ',
    'l': '第一次使用本設備時，請先充電3個小時。充電時將亮起綠色燈號，充電完畢燈號會自動熄滅。 ',
    'm': 'Q2. 如何幫心美特充電？ ',
    'n': '請使用原廠盒內micro USB充電線充電。將充電線插入設備充電口，並將另一頭接連接到計算機USB接口或者輸出電壓為5V的手機充電器進行充電。 ',
    'o': 'Q3. 設備充滿電後，電池續航時間大約為多久？ ',
    'p': '一般而言，若是使用頻率是一天測量2次，續航時間大約為3個月左右。實際的續航狀況會受測量及開關機的次數的影響，另外外部的環境的變化也會改變電池的電量，如在極冷或極熱的溫度下其可用電量會相對減少；此外，由於電池本身為消耗品，可用電量會隨使用年限增加而漸漸變少。 ',
    'q': 'Q4. 當設備低電量時，會有任何警示嗎？ ',
    'r': '當設備自動偵測到低電量時，會以每5秒“嗶”1聲方式告知，此時仍可進行量測，請量測完後儘快進行充電。 ',
    's': '當設備電量極低時，開啟後會長嗶1聲並立即自動關機，此時請立即進行充電。 ',
    't': '心美特有自動關機省電設計，當設備閒置3分鐘，會自動關機並發出“嗶”1聲以告知。 ',
    'u': '手機、平板與APP相關問題',
    'v': 'Q5. 如何註冊與登錄心美特APP？ ',
    'w': '您可以依照APP內指示進行註冊與登錄。 ',
    'x': 'Q6. 心美特如何與手機進行藍牙配對？ ',
    'y': '請開啟設備電源開關，並依照APP內指示進行藍牙配對，或參考以下指示進行配對：',
    'z': '安卓用戶',
    'aa': '1.開啟設備電源進入待機狀態',
    'bb': '2.在Android手機中設定→藍牙→開啟藍牙',
    'cc': '3.掃描附近的裝置，選取[CmateH]完成藍牙配對',
    'dd': '蘋果用戶',
    'ee': '請先在設定中開啟藍牙功能，無須進行配對，直接配合APP使用即可。 ',
    'ff': '量測相關問題',
    'gg': 'Q7. 量測時，放置設備的正確位置是怎樣的？ ',
    'hh': '請手持設備並“正面向上”輕壓於胸口前位置（切勿倒置），四個接觸點需穩定接觸到皮膚。 ',
    'ii': 'Q8. 已按照圖中標示的位置進行量測，為何無法成功？ ',
    'jj': '由於每個人的體型皆不同，若是無法從指南所建議的量測位置成功量測時，可以嘗試將設備往左邊平行位移至左邊乳頭上方的位置進行測量。 ',
    'kk': 'Q9. 其他量測不成功的可能原因是什麼？ ',
    'll': '皮膚乾燥：由於個人膚質因人而異，屬於乾性膚質的使用者，建議可以在皮膚均勻塗抹適量耦合劑以增加其量測成功率。 ',
    'mm': '皮膚潮濕：量測前請確認胸前皮膚無汗水附著，請擦乾後再行量測。 ',
    'nn': '環境：由於設備是屬於一種電生理信號的放大裝置，因此請盡量避免在干擾源較大的環境下進行量測。 ',
    'oo': 'Q10. 量測時的正確姿勢是怎樣的？ ',
    'pp': '量測時採坐姿並能有靠背的椅子為佳，並將設備的四個接觸點輕壓並穩定接觸到胸前皮膚。量測期間不要晃動身體、四肢或說話，當設備檢測到心跳生理信號時會發出間斷提示“嗶”聲，以識別量測信號的質量。 ',
    'qq': 'Q11. 為什麼在量測時，“嗶”聲時有時無？這是正常的嗎？ ',
    'rr': '若在量測時發生偵測心跳的嗶聲時有時無，則表示量測採集的信號不完整；可能是在量測中因手或身體的晃動而導致接觸點無法正常接觸到皮膚，若遇此情形請重新量測，直到在30秒的紀錄中都能聽到此提示音為止，再進行上傳分析。 ',
    'ss': 'Q12. 什麼是心率健康、情緒與精神狀態、疲勞指數？ ',
    'tt': '將量測30秒所紀錄的數據，通過設備AI計算分析技術，快速呈現出的心率變異狀態，並以不同顏色來表示其量測當下的結果；心率健康是反應其規律性狀態變化，情緒與精神狀態及疲勞指數乃是反應其生理、心理的健康狀態指標。 ',
    'uu': 'Q13. 在APP內已有量測功能鍵，為何在設備本體上還有一個「量測按鍵」呢？ ',
    'vv': '在一般情況下，使用者可以依照APP的指引來操作在手機或平板電腦內APP的量測按鈕進行量測；若使用者暫時沒有手機或平板電腦，卻有量測需求時，則可以使用此「量測按鍵」進行量測與紀錄，待之後再用手機或平板電腦按下APP內的「上傳」功能鍵將測量記錄上傳；此種方式，也可適用於來不及打開APP ，但必須要及時量測的手動上傳模式。 ',
    'ww': 'Q14. 請問使用者可以以平躺姿勢進行量測嗎?',
    'xx': '使用者可以以平躺的姿勢進行量測。此時若不方便同時操作APP時，可採用手動上傳模式進行；也可請旁人協助操作APP，直接以APP來進行量測上傳。 ',
    'yy': '設備相關問題',
    'zz': '15. 上傳成功的測量記錄是儲存在雲端上還是在設備內？ ',
    'aaa': '上傳成功的測量記錄會在設備端自動刪除並儲存在雲端上，然而若是在上傳測量記錄時因網絡信號不佳而無法上傳成功時，該未上傳的記錄會儲存在設備內，待網絡信號穩定時，可再行上傳。設備內可供儲存量測記錄為30筆，當紀錄額滿時，將無法使用本裝置，必須刪除部分或全部的記錄，才可正常運作。 ',
    'bbb': 'Q16. 設備開機後無法使用且每秒發出2次“嗶”聲？ ',
    'ccc': '表示設備內存儲的記錄已滿，此時必須使用APP內上傳功能中的刪除鍵進行部分或全部刪除後，方能正常使用。 ',
    'ddd': 'Q17. 設備是否有防水功能？ ',
    'eee': '設備本身並不支持防水功能，請盡量避免在潮濕的環境下使用。 ',
    'fff': 'Q18. 設備是否要定期清理？ ',
    'ggg': '由於設備的4個金屬接觸點必須直接接觸到皮膚，因此長期使用後金屬接觸點表面會沾黏到身體的皮屑或油脂，而影響其導電性；此時可用棉花棒沾濕清潔或是用沾有稀釋酒精成分的布進行清潔，再擦乾即可。 ',
    'hhh': 'Q19. 為什麼量測時間會出現異常，例如出現過去時間的狀況？ ',
    'iii': '這是設備本身未與手機或平板電腦的時間同步所致，此情況可能發生於當用戶第一次使用裝置進行量測，但於當下並未開啟手機或平板的APP，待量測完畢後再行開啟APP上傳，此時在APP上所顯示的量測時間會與上傳時間差異很大。建議進行第二次量測，此時設備會與手機或平板電腦的時間同步，即可解決時間異常問題。 ',
    'jjj': '若想了解更多產品信息，請掃描下方二維碼，關注【蓋德健康】微信服務號。 '
  }
}
